
import {Vue, Component, Prop} from "vue-property-decorator";

import SvgIcon from "@jamescoyle/vue-icon";
import {
  mdiStore,
  mdiDomain,
} from "@mdi/js";
import { Getter } from "vuex-class";

@Component({
  components: {
    SvgIcon,
    mdiStore,
    mdiDomain,
  },
})
export default class KeyStatus extends Vue {
    @Prop({default: () => ({})})
    public currentKey: any;

    @Prop({default: ""})
    public customStatus: string;

    @Prop({default: true})
    public detail: boolean;

    @Getter private isMobile: boolean;

    private mdiStore = mdiStore;
    private mdiDomain  = mdiDomain;

    get keyReferenceAgency(): any|undefined {
      return this.currentKey?.Relays?.find((r) => r.type === "AGENCY") || this.currentKey?.Relays?.[0];
    }

    get currentBox(): any|undefined {
      return this.currentKey?.currentLocation?.Box;
    }

    get currentBuilding(): any|undefined {
      return this.currentBox?.Building;
    }

    get currentRelay(): any|undefined {
      return this.currentKey.status === "IN_TRANSIT"
        ? this.keyReferenceAgency
        : this.currentBuilding?.Relays?.[0];
    }

    get keyStatus(): string {
      if (this.currentBox?.ConnectedBox) {
        return "IN_CONNECTED_BOX";
      } else if (this.currentBox?.Building?.Relays?.length === 0) {
        return "IN_BUILDING";
      }
      return this.currentKey.status;
    }
}
